import { Component } from '@angular/core';

@Component({
  selector: 'app-llp-jobstatus-batch-trigger',
  template: `
    <img
      
      width="20px"
      height="20px"
      align-self="center"
      src="./assets/images/play.png"
      alt=""
      *ngIf="isShow"
      (click)="onBatchRun()"
    />
  `,
  styles: [],
})
export class LlpJobstatusBatchTriggerComponent {
  params: any;
  isShow: boolean = false;

  agInit(params: any): void {
    this.params = params;
    if (
      this.params.data.batch_name.toLowerCase() == 'Calc min max inventory batch'.toLowerCase() ||
      this.params.data.batch_name.toLowerCase() == 'Usagevsreceipt Calculation batch'.toLowerCase() ||
      this.params.data.batch_name.toLowerCase() == 'Monthly Pipeline Addition Batch'.toLowerCase()

    ) {
      this.isShow = true;
    }
  }

  onBatchRun() {
    this.params.context.componentParent.onBatchTrigger(this.params.data);
  }
}
